export var CALCULATOR_TYPE = {
  /** калькулятор на странице /calculator */
  Main: 'main',
  /** калькулятор на странице партнеров /calculator/partners */
  Partners: 'partners',
  /** калькулятор на страницах продуктах и на промо страницах посвященных продукту */
  Product: 'product',
  /**  остальные калькуляторы на сайте */
  Additional: 'additional',
  /** тестовый калькулятор /calculator/test */
  Test: 'test'
};